import { useEffect } from 'react';
import HeaderVariant from '../../constants/HeaderVariant';
import { getEditorColor, renderColor } from '../../util/ColorUtil';
import { isItUndefined, modifyLinks } from '../../util/DataUtil';
import { getObjectValueByMachineName } from '../../util/ObjectUtil';
import { formatCommaSeparator } from '../../util/RegexUtil';

const TemplateHeader = (props) => {
  const emphasizedTextColor = getEditorColor(
    isItUndefined(props?.children?.field_description_long)
  );
  const dataSet = { ...props?.global, ...props?.dataSet };

  useEffect(() => {
    if (
      isItUndefined(props?.children?.field_header_variant) ==
      HeaderVariant.HEADER_WITH_STATS
    ) {
      let doc = document.getElementsByClassName('template-header-stats')[0];
      let singleStat = document?.getElementsByClassName('single-stat')[0];
      if (doc.getBoundingClientRect().left < 50) {
        doc.style.marginTop = '24px';
        doc.style.width = '100%';
      }
      if (singleStat?.getBoundingClientRect().left < 50) {
        singleStat.style.marginTop = '24px';
        singleStat.style.width = '100%';
        singleStat.style.justifyContent = 'flex-start';
      }
    }
  }, []);

  const renderValues = (data) => {
    if (!data || data.length === 0) return;

    return data.map((item, index) => {
      return (
        <div className="stats" key={`stat-${index}`}>
          <span
            className="label"
            dangerouslySetInnerHTML={{
              __html: modifyLinks(
                formatCommaSeparator(
                  getObjectValueByMachineName(
                    isItUndefined(item?.field_description_formatted),
                    dataSet
                  )
                )
              ),
            }}
          ></span>
          <span
            className="value"
            dangerouslySetInnerHTML={{
              __html: modifyLinks(
                getObjectValueByMachineName(
                  isItUndefined(item?.field_value_formatted)
                ),
                dataSet
              ),
            }}
          ></span>
        </div>
      );
    });
  };
  return (
    <div
      className={
        props?.regionColor && props?.regionColor !== 'none'
          ? `template-header ${props?.regionColor}`
          : `template-header ${renderColor(isItUndefined(props?.children?.field_text_color))}`
      }
    >
      <div
        className={`inner-container ${props?.children?.field_header_variant[0]?.value == HeaderVariant.HEADER_WITH_STATS ? 'header-stats' : ''}`}
      >
        <div
          className={`template-header-details${isItUndefined(props?.children?.field_header_variant) == HeaderVariant.HEADER ? ' header' : ''}`}
        >
          <h1 className="header-title">
            {props?.children?.field_title[0]?.value}
          </h1>
          <span
            dangerouslySetInnerHTML={{
              __html: modifyLinks(
                getObjectValueByMachineName(
                  props?.children?.field_description_long[0]?.value,
                  dataSet
                )
              ),
            }}
            className={`header-description ${emphasizedTextColor ? emphasizedTextColor : ''}`}
          ></span>
        </div>
        {isItUndefined(props?.children?.field_header_variant) ==
          HeaderVariant.HEADER_WITH_STATS && (
          <div
            className={`template-header-stats ${props?.children?.field_header_stats?.stats_coloured_fields_type.length == 1 ? 'single-stat' : ''}`}
          >
            {renderValues(
              props?.children?.field_header_stats?.stats_coloured_fields_type
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default TemplateHeader;
